import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';

import InstantBuy from 'pages/market/instant-buy/page';

const Column = styled(Vertical)`
  padding: 0 var(--triple-unit);
`;

const MobileInstantBuyPage = () => {
  return (
    <Column>
      <InstantBuy />
    </Column>
  );
};

export default MobileInstantBuyPage;
